module.exports = __webpack_public_path__ + "img/daning.31eefefa.jpg";